import api from '../../plugins/api';

const login = (params) => {
  return api.post('/api/login', params);
};

export default login;
